var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable no-underscore-dangle */
import { useEffect, useLayoutEffect, useRef, useState, } from "react";
import { useLoanNickNameMutation } from "../../../queries/useLoanNickNameMutation/useLoanNickNameMutation";
import { useConfig } from "../../../hooks/useConfig";
import i18n from "../../../strings/i18n";
import { BodyWrapper, FooterButton, FooterWrapper, Header, HeaderWrapper, ModalBody, ModalContent, NickNameModal, } from "./LoanNickNameModal.styles";
import triggerAnalytics from "../../../helpers/triggerAnalytics";
import { PAGE_SUBFUNCTIONS } from "../../../const/analytics";
import { useAccountSummary } from "../../../const/syfApiQueries";
import NickNameInput from "./NickNameInput";
import NickNameError from "./NickNameError";
import inputSchema from "./LoanNickNameSchema";
import { IMAGE_API_FAILURE } from "../../../const/assets";
var LoanNickNameModal = function (_a) {
    var _b, _c;
    var containerId = _a.containerId, isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, accountId = _a.accountId, nickName = _a.nickName, handleLoanNicknameClose = _a.handleLoanNicknameClose, type = _a.type;
    var config = useConfig();
    var _d = useState(nickName || ""), inputValue = _d[0], setInputValue = _d[1];
    var _f = useState(), err = _f[0], setErr = _f[1];
    var _g = useState(false), apiError = _g[0], setApiError = _g[1];
    var accountSummaryData = useAccountSummary(accountId).data;
    var inputRef = useRef(null);
    var clientName = (_b = accountSummaryData === null || accountSummaryData === void 0 ? void 0 : accountSummaryData.product) === null || _b === void 0 ? void 0 : _b.clientId;
    var updateNickName = useLoanNickNameMutation({
        config: config,
        keyProps: { accountId: accountId, accountIdType: "guid" },
    });
    var handleInputChange = function (value) {
        setInputValue(value);
        var result = inputSchema.safeParse(value);
        if (!result.success) {
            setErr(result.error.errors[0].message);
        }
        else {
            setErr(undefined);
        }
    };
    var handleInputOnBlur = function () {
        setInputValue(function (prev) { return prev.trim(); });
    };
    var closeModal = function () {
        setIsOpen(false);
        setInputValue(nickName || "");
        setErr(undefined);
        if (apiError)
            setApiError(false);
        handleLoanNicknameClose === null || handleLoanNicknameClose === void 0 ? void 0 : handleLoanNicknameClose();
    };
    var handleSuccess = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updateStatus, _e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!err) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, updateNickName.mutateAsync({
                            nickName: inputValue,
                        })];
                case 2:
                    updateStatus = (_a.sent()).updateStatus;
                    if (updateStatus === "Success") {
                        setInputValue(inputValue || "");
                        setIsOpen(false);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _e_1 = _a.sent();
                    setApiError(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (!clientName || !isOpen)
            return;
        triggerAnalytics({
            clientName: clientName,
            previouslyVisited: window.location.pathname,
            pageSubFunction: PAGE_SUBFUNCTIONS.LOAN_NICKNAME,
            product: type,
        });
    }, [clientName, isOpen, type]);
    useLayoutEffect(function () {
        var el = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current;
        if (!isOpen || !el)
            return;
        requestAnimationFrame(function () {
            var _a, _b;
            el.focus();
            var length = (_b = (_a = el === null || el === void 0 ? void 0 : el.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
            el.setSelectionRange(length, length);
        });
    }, [isOpen]);
    return (_jsx(NickNameModal, __assign({ id: "simple-modal", containerId: containerId, "aria-label": "Nick name modal", "data-testid": "nick-name-modal", "data-cy-include": true, isOpen: isOpen, className: "nick-name-modal", preventScroll: true, escapeModalHandler: closeModal }, { children: _jsx(ModalContent, __assign({ id: "modal-content", "data-cy": "loan-nickname-modal-content" }, { children: apiError ? (_jsx(NickNameError, { img: "".concat((_c = config.hosts) === null || _c === void 0 ? void 0 : _c.assets).concat(IMAGE_API_FAILURE), handleClose: closeModal, clientName: clientName, type: type })) : (_jsxs(_Fragment, { children: [_jsx(HeaderWrapper, { children: _jsx(Header, { children: i18n({ labels: "loanNickNameHeader" }) }) }), _jsx(BodyWrapper, { children: _jsxs(ModalBody, { children: [i18n({ labels: "loanNicknameText" }), " ", _jsx("strong", { children: i18n({ labels: "loanNicknameStrongText" }) })] }) }), _jsx(NickNameInput, { inputValue: inputValue, handleInputChange: handleInputChange, handleInputOnBlur: handleInputOnBlur, error: err, ref: inputRef }), _jsxs(FooterWrapper, { children: [_jsx(FooterButton, __assign({ "data-type": "loan nickname", "data-reason": "cancel", "data-object": "button", "data-analytics": "clicktrackingevent", id: "nickname-close", "data-testid": "nickname-close", ariaLabel: "Close nickname modal", buttonType: "ghost", onClick: function (e) {
                                    e.stopPropagation();
                                    closeModal();
                                } }, { children: i18n({ button: "cancel" }) })), _jsx(FooterButton, __assign({ "data-type": "loan nickname", "data-reason": "save", "data-object": "button", "data-analytics": "clicktrackingevent", id: "nickname-submit", "data-testid": "nickname-submit", disabled: !!err || inputValue.trim().length === 0, ariaLabel: "Submit nickname", buttonType: "primary", onClick: function (e) {
                                    e.stopPropagation();
                                    handleSuccess();
                                } }, { children: i18n({ button: "save" }) }))] })] })) })) })));
};
export default LoanNickNameModal;
//# sourceMappingURL=LoanNickNameModal.js.map